(() => {
  const key = 'darkside:continue-shopping:v1';
  const selector = 'a[data-continue-shopping]';

  function browsingUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin ||
          !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|products|search|pages|blogs)(?:\/|$)/i.test(url.pathname)) return '';
      url.searchParams.delete('preview_theme_id');
      url.searchParams.delete('_fd');
      url.searchParams.delete('pb');
      return url.pathname + url.search + url.hash;
    } catch (_) {
      return '';
    }
  }

  let previous = '';
  try {
    previous = browsingUrl(sessionStorage.getItem(key));
  } catch (_) {}
  previous = browsingUrl(document.referrer) || previous;

  function remember() {
    const current = browsingUrl(window.location.href);
    if (!current) return;
    previous = current;
    try {
      sessionStorage.setItem(key, current);
    } catch (_) {}
  }

  function updateLink(link) {
    const destination = browsingUrl(window.location.href) || previous;
    if (destination) link.setAttribute('href', destination);
  }

  function updateLinks(root) {
    if (root.matches?.(selector)) updateLink(root);
    root.querySelectorAll?.(selector).forEach(updateLink);
  }

  remember();
  updateLinks(document);
  window.addEventListener('pagehide', remember);
  window.addEventListener('pageshow', () => {
    remember();
    updateLinks(document);
  });
  document.addEventListener('submit', remember, true);
  document.addEventListener('click', (event) => {
    remember();
    const link = event.target.closest?.(selector);
    if (!link) return;
    updateLink(link);
    const drawer = link.closest('cart-drawer');
    if (drawer && browsingUrl(window.location.href) &&
        !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      drawer.close();
    }
  }, true);
  ['pointerover', 'focusin'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const link = event.target.closest?.(selector);
      if (link) updateLink(link);
    });
  });
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(updateLinks));
  }).observe(document.body, { childList: true, subtree: true });
})();
